var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVegan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6667 27.6667C31 32.6854 26.3333 45.0001 26.3333 45.0001C26.3333 45.0001 19.6667 27.6667 13 23.6667",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0427 17.6134L45.832 25.8267C46.344 31.1547 42.3493 35.8987 37.0213 36.4134C31.7947 36.9147 27.0587 33.0934 26.5547 27.8667C26.4348 26.6235 26.5609 25.3688 26.9259 24.1744C27.291 22.98 27.8877 21.8691 28.6821 20.9053C29.4765 19.9416 30.453 19.1437 31.5558 18.5574C32.6586 17.971 33.8661 17.6077 35.1093 17.488L43.8667 16.6454C44.1505 16.6186 44.4334 16.7055 44.6534 16.8869C44.8733 17.0684 45.0123 17.3296 45.04 17.6134",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0002 55.6667C43.7282 55.6667 55.6668 43.728 55.6668 29C55.6668 14.272 43.7282 2.33337 29.0002 2.33337C14.2722 2.33337 2.3335 14.272 2.3335 29C2.3335 43.728 14.2722 55.6667 29.0002 55.6667Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegan);
export default __webpack_public_path__ + "static/media/vegan.ddb1d2edd70b21c18058379538cdac4c.svg";
export { ForwardRef as ReactComponent };